
import { defineComponent, PropType } from "vue";

export type Icons =
  | "close"
  | "female"
  | "logo"
  | "male"
  | "remove"
  | "search"
  | "star";

export default defineComponent({
  props: {
    name: String as PropType<Icons>,
  },
});
